module.exports = __webpack_public_path__ + "img/stapled-glossy.3ef32fad.png";